import React from 'react';
import { Button } from '@mui/material';

interface ActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  contentId?: string;
  action?: string;
  variant?: 'primary' | 'secondary';
  sx?: any;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  onClick,
  contentId,
  action,
  variant = 'primary',
  sx,
}) => {
  return (
    <Button
      onClick={onClick}
      data-content-id={contentId}
      data-action={action}
      sx={{
        background: variant === 'primary' ? 'var(--primary-blue)' : '#6c757d',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        margin: '8px 4px',
        textTransform: 'none',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: variant === 'primary' ? 'var(--primary-blue-dark)' : '#5a6268',
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default ActionButton;

